import React from 'react';
import {connect} from 'react-redux';
import {Trans, withTranslation} from 'react-i18next';
import AutoCompletion from './components/auto-completion/index';
import {
    getAddedCollaborators,
    autoCompleteEnteredValue,
    share,
    findCollaborators, getSharingDetailsPopup
} from '../../../../../../../actions/sharingDetailsActions';
import AddToContact from './components/add-to-contact/index';
import AddCollaboratorsField from './components/add-collaborators-field/index';
import UpdateDirectory from './components/update-directory/index';
import {hasDuplicatedEmail, isEmailValid, isEmpty} from '../../../../../../../actions/addCollaboratorActions';
import RightSelection from "./components/right-selection";
import SharingButton from './components/sharing-button';
import ListOfCollaborators from './components/list-of-collaborators';
import {labelStateUpdating, postCreateLabel} from "../../../../../../../actions/contactsGroupItemActions";
import Notify from "./components/notify";
import Loader from "../../../../../../components/sprite/components/loader";
import MsgSharingDetailsBar from './components/msg-sharing-details-bar';
import './index.css';
import SwitchButton from '../../../../../../components/switch-button';
import {toggleOrgUnit} from '../../../../../../../actions/directoryGroupActions';
import {sharedWordRemove} from '../../../../../../utils';

class AddCollaboratorsPopup extends React.Component {

	constructor(props){
		super(props);

		this.state = {
			selectedActive: false,
			selectedIndex: -1,
		};

		this.remainingCollaboratorsCall = null;
		this.addCollaborator = this.addCollaborator.bind(this);
		this.handleToggleOrgUnit = this.handleToggleOrgUnit.bind(this);
        this.share = this.share.bind(this);
	}

    componentDidMount(){
		if(this.props.sharingDetailsPopup[2]){
			this.props.setFindCollaborators(this.props.sharingDetailsPopup[2], this.props.collaboratorsPageSize);
		} else {
			if(this.props.selectedContactsGroup.type === "system"){
				this.props.setFindCollaborators(6, this.props.collaboratorsPageSize);
			} else {
				this.props.setFindCollaborators(this.props.selectedContactsGroup.id, this.props.collaboratorsPageSize);
			}
		}


        /*this.remainingCollaboratorsCall = setInterval(() => {
            this.props.setFindCollaborators(this.props.selectedContactsGroup.id, this.props.collaboratorsPageSize);
        }, 30000);*/
	}

    /*componentWillUnmount(){
		clearInterval(this.remainingCollaboratorsCall)
	}*/

	addCollaborator(e){

        document.getElementById('addCollaboratorsField').focus();

		this.props.setAutoCompleteEnteredValue("");

		if(this.props.isEmpty){
			this.props.setIsEmpty(false);
		}

		if(this.props.isEmailValid === false){
			this.props.setIsEmailValid(true);
		}

		if(this.props.hasDuplicatedEmail){
			this.props.setHasDuplicatedEmail(false);
		}

		/*
		* If a click event is triggered
		* */

		let collaboratorsArray = [];

		this.props.autoComplete.forEach(item => {
			if(item.id === e.currentTarget.id){
				collaboratorsArray = collaboratorsArray.concat({
					"groupId": this.props.sharingDetailsPopup[2] || this.props.selectedContactsGroup.id,
					"id": item.id ? item.id : item.email,
					"name": item.name,
					"email": item.email,
					"permission": this.props.rightToAdd,
					"type": item.type,
					"addToContact": false,
					"toRemove": false
				});
			}

			return collaboratorsArray;
		});

		this.props.getAddedCollaborators(...collaboratorsArray);
		document.getElementById("addCollaboratorsField").value = "";
	}

    share(){

		if(this.props.sharingDetailsPopup[2]){
			this.props.labelStateUpdating(this.props.sharingDetailsPopup[2]);
		} else {
			this.props.labelStateUpdating(this.props.selectedContactsGroup.id);
		}


	    if(document.getElementById("addCollaboratorsField").value.trim() === "" && this.props.addedCollaborators.length === 0){
		    this.props.setIsEmpty(true);
	    } else if (this.props.targetedContact && this.props.findLabels.contactsGroups.length === 0) {

		    /*
			* TargetedContact with no label
			* */

		    this.props.postCreateLabel('🥳 My First Shared Group', true);

	    } else {
		    this.props.share();
	    }

    }

	displayPopupSharingInfoTitle () {
		if(this.props.selectSeveralContactsGroups.length > 0){

			let activeLabelInsideSeveralSelectedLabels = false;

			this.props.selectSeveralContactsGroups.forEach( item => {
				if(item.name === this.props.selectedContactsGroup.name) {
					activeLabelInsideSeveralSelectedLabels = true;
				}
			});

			if(this.props.selectSeveralContactsGroups.length > 2){

				/*
				* Three or more selected
				* */

				if(activeLabelInsideSeveralSelectedLabels){
					return <Trans i18nKey="popupSharingInfoAndMoreLabels" values={
						{
							labelName: this.props.selectedContactsGroup.name,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				} else {
					return <Trans i18nKey="popupSharingInfoAndMoreLabels" values={
						{
							labelName: this.props.selectSeveralContactsGroups[0].name,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				}
			} else if (this.props.selectSeveralContactsGroups.length > 1) {

				/*
				* Two or more selected
				* */

				if(activeLabelInsideSeveralSelectedLabels){
					return <Trans i18nKey="popupSharingInfoAndOneLabel" values={
						{
							labelName: this.props.selectedContactsGroup.name,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				} else {
					return <Trans i18nKey="popupSharingInfoAndOneLabel" values={
						{
							labelName: this.props.selectSeveralContactsGroups[0].name,
							selectedLabelsNumber: this.props.selectSeveralContactsGroups.length - 1
						}
					}/>
				}
			} else {

				/*
				* Only One selected
				* */

				if(activeLabelInsideSeveralSelectedLabels){
					return <Trans i18nKey="popupSharingInfo" values={
						{
							labelName: this.props.selectedContactsGroup.name
						}
					}/>
				} else {
					return <Trans i18nKey="popupSharingInfo" values={
						{
							labelName: this.props.selectSeveralContactsGroups[0].name
						}
					}/>
				}

			}

		} else {
			return <Trans i18nKey="popupSharingInfo" values={
				{
					labelName: this.props.selectedContactsGroup.name
				}
			}/>
		}
	}

	handleToggleOrgUnit () {
		if(this.props.selectedContactsGroup.ouSharingPermission === 'INHERIT_FROM_PARENT'){
			this.props.toggleOrgUnit(this.props.selectedContactsGroup.id, 'SPECIFIC_PERMISSIONS', this.props.selectedContactsGroup.ownerId);
		} else {
			this.props.toggleOrgUnit(this.props.selectedContactsGroup.id, 'INHERIT_FROM_PARENT', this.props.selectedContactsGroup.ownerId);
		}
	}

	render(){
		if(this.props.findLabels && this.props.findCollaborators){

			if(this.props.selectedContactsGroup.permission === 'READ_ONLY'){
				return (
					<div className="add-collaborators position-relative">
						{this.props.t("textNoAccessSharingSetting")}
					</div>
				)
			} else {
				return (
					<div className="add-collaborators position-relative">
						{
							(this.props.selectedCollaborator === null) && <div>
								<div className="d-flex align-items-center mb-3">
									<div
										className="pic bg-primary rounded-circle d-flex align-items-center justify-content-center mr-2 text-center">
										<svg width="1em" height="1em" viewBox="0 0 16 16">
											<line fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      x1="5.425" y1="9.046" x2="10.575" y2="11.62"/>
											<line fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      x1="5.425" y1="6.954" x2="10.575" y2="4.379"/>
											<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      d="M15,3.334c0,1.287-1.046,2.332-2.333,2.332 s-2.334-1.045-2.334-2.332C10.333,2.046,11.38,1,12.667,1S15,2.046,15,3.334"/>
											<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      d="M15,12.667C15,13.954,13.954,15,12.667,15 s-2.334-1.046-2.334-2.333s1.047-2.334,2.334-2.334S15,11.38,15,12.667"/>
											<path fill="none" stroke="#fff" strokeWidth="1.5" strokeMiterlimit="10"
											      d="M5.666,8c0,1.287-1.045,2.333-2.332,2.333 C2.046,10.333,1,9.287,1,8s1.046-2.334,2.334-2.334C4.62,5.666,5.666,6.713,5.666,8"/>
										</svg>
									</div>
									<h2>
										{this.displayPopupSharingInfoTitle()}
									</h2>
								</div>
								{
									(
										this.props.selectedContactsGroup.type === "childDirectory"
										|| this.props.selectedContactsGroup.type === "childDirectoryLv2"
									) && <div className="d-flex my-4 justify-content-around">
										<div>
											Inherited from {sharedWordRemove(this.props.selectedContactsGroup.parentName)}
										</div>
										<div>
											<SwitchButton
												active={this.props.selectedContactsGroup.ouSharingPermission === 'SPECIFIC_PERMISSIONS'}
												onClick={ this.handleToggleOrgUnit }
											/>
											Specific permission
										</div>
									</div>
								}
								<div className={`add-collaborators_area${
									(
										this.props.selectedContactsGroup.type === "childDirectory"
										|| this.props.selectedContactsGroup.type === "childDirectoryLv2"
									) && this.props.selectedContactsGroup.ouSharingPermission === "INHERIT_FROM_PARENT" ? ' disabled': ''}`}>
									<div className="d-flex align-items-stretch mb-2">
										<div className={`input-group collaborators-field-wrapper${this.props.isSharing || (this.props.isUserListAddCollaboratorsPopupShown && !this.props.selectOneLabelFromPopup) ? ' collaborators-field-wrapper__disabled' : ''}`}>
											<div className="input-wrapper d-flex p-1">
												<AddCollaboratorsField launchShare={this.share}/>
											</div>
											<div className="input-group-append">
												<UpdateDirectory/>
											</div>
										</div>
										{
											this.props.addedCollaborators.length
												?
												<RightSelection/>
												:
												null
										}
									</div>
									{
										this.props.isEmpty
										?
											<div className="alert alert-danger mt-3">{this.props.t("fieldEmpty")}.</div>
										:
											this.props.isEmailValid === false
											?
												<div className="alert alert-danger mt-3">{this.props.t("popupSharingInvalidEmailError")}.</div>
											:
												this.props.hasDuplicatedEmail
												?
													<div className="alert alert-danger mt-3">{this.props.t("emailExistAlreadyText")}
														</div>
												:
													null
									}
									{
										this.props.autoCompleteEnteredValue.length > 1
										?
											<AutoCompletion
												selectedIndex={this.state.selectedIndex}
												selectedActive={this.state.selectedActive}
												addCollaboratorClickHandler={this.addCollaborator}
											/>
										:
											null
									}
									<AddToContact/>
									<Notify/>
									<SharingButton from={this.props.sharingDetailsPopup[2]}/>
								</div>
							</div>
						}
						{
							this.props.findCollaborators.collaborators?.length > 1 && this.props.sharingDetailsPopup[2] !== "severalLabels" && <ListOfCollaborators disabled={
								(
									this.props.selectedContactsGroup.type === "childDirectory"
									|| this.props.selectedContactsGroup.type === "childDirectoryLv2"
								) && this.props.selectedContactsGroup.ouSharingPermission === "INHERIT_FROM_PARENT" ? ' disabled': ''
							}/>
						}
						{
							this.props.msgSharingDetailsBar.length > 0
							&& <MsgSharingDetailsBar/>
						}
					</div>
				)
			}

		} else {
			return <Loader/>
		}

	}
}

const mapStateToProps = (state) => {
	return {
		findLabels: state.contactsGroupItemReducer.findLabels,
		findCollaborators: state.sharingDetailsReducer.findCollaborators,
		autoCompleteEnteredValue : state.sharingDetailsReducer.autoCompleteEnteredValue,
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        selectSeveralContactsGroups: state.contactsGroupItemReducer.selectSeveralContactsGroups,
        collaboratorsPageSize: state.sharingDetailsReducer.collaboratorsPageSize,
        addedCollaborators: state.sharingDetailsReducer.getAddedCollaborators,
        autoComplete: state.sharingDetailsReducer.getAutoComplete,
		profile: state.profileReducer.getProfile,
		isEmpty: state.addCollaboratorDetailsReducer.isEmpty,
		isEmailValid: state.addCollaboratorDetailsReducer.isEmailValid,
		hasDuplicatedEmail: state.addCollaboratorDetailsReducer.hasDuplicatedEmail,
		rightToAdd: state.sharingDetailsReducer.rightToAdd,
		selectedContacts: state.contactReducer.selectedContacts,
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		setGmailAddOnData: state.profileReducer.setGmailAddOnData,
		targetedContact: state.contactReducer.targetedContact,
		selectedCollaborator: state.sharingDetailsReducer.selectedCollaborator,
		msgSharingDetailsBar: state.msgBarReducer.msgSharingDetailsBar,
		isUserListAddCollaboratorsPopupShown: state.popupReducer.isUserListAddCollaboratorsPopupShown,
		selectOneLabelFromPopup: state.contactsGroupItemReducer.selectOneLabelFromPopup,
		isSharing : state.sharingDetailsReducer.isSharing
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        setFindCollaborators : (selectedLabelId, pageSize) => {
            dispatch(findCollaborators(selectedLabelId, pageSize))
        },
		setAutoCompleteEnteredValue : (string) => {
			dispatch(autoCompleteEnteredValue(string))
		},
		getAddedCollaborators : (array) => {
			dispatch(getAddedCollaborators(array))
		},
        share : (object) => {
            dispatch(share(object))
        },
		setIsEmpty : (boolean) => {
			dispatch(isEmpty(boolean))
		},
		setIsEmailValid : (boolean) => {
			dispatch(isEmailValid(boolean))
		},
		setHasDuplicatedEmail : (boolean) => {
			dispatch(hasDuplicatedEmail(boolean))
		},
        postCreateLabel: (string, boolean, contact) => {
            dispatch(postCreateLabel(string, boolean, contact))
        },
        labelStateUpdating: (labelId) => {
            dispatch(labelStateUpdating(labelId))
        },
		toggleOrgUnit: (groupId, ouSharingPermission, ownerId) => {
			dispatch(toggleOrgUnit(groupId, ouSharingPermission, ownerId))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddCollaboratorsPopup));
